import type {
  ColumnConfig,
  ColumnFormatter,
  MetaData,
} from '@/components/datatable/dataTableTypes';
import { makeNumberFormatter } from '@/utils/dataTable';
import type { PrefilterTab } from '@/utils/prefilter';
import type { CreateOperatingCostInvoiceLineItemV1Dto } from '@/openapi';

import type { OperatingCostInvoiceLineItemSimple } from '../operatingCostInvoiceTypes';

import { UNIT_SUFFIXES } from './operatingCostInvoiceLineFormConfig';

const makeUnitSuffixFormatter = (): ColumnFormatter => (rawValue) =>
  UNIT_SUFFIXES[rawValue as CreateOperatingCostInvoiceLineItemV1Dto.unit] ?? rawValue;

export const columns: ColumnConfig[] = [
  { field: 'invoiceItemSource', clusterable: true, template: 'invoiceSource', align: 'center' },
  { field: 'id', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'nameOnStatement' },
  { field: 'sfmPositionName' },
  { field: 'isFlatRate', type: 'boolean' },
  { field: 'totalAmount', type: 'number', align: 'right', formatter: makeNumberFormatter() },
  {
    field: 'customerAmount',
    type: 'number',
    align: 'right',
    formatter: makeNumberFormatter(),
  },
  { field: 'totalArea', type: 'number', align: 'right', formatter: makeNumberFormatter() },
  { field: 'customerArea', type: 'number', align: 'right', formatter: makeNumberFormatter() },
  { field: 'unit', align: 'center', formatter: makeUnitSuffixFormatter() },
  { field: 'status', type: 'enum', template: 'costInvoiceItemStatusBadge', align: 'center' },
];

export function createOperationCostInvoiceItemsPrefilterTabs(
  _data: OperatingCostInvoiceLineItemSimple[],
): PrefilterTab[] {
  return [
    {
      title: 'labels.tabsAll',
      isClearFilterTab: true,
      options: [
        {
          title: 'labels.tabsAll',
          customFilterFn: (data) => data,
          initialActive: true,
        },
      ],
    },
    {
      title: 'pages.costInvoice.tabs.status',
      options: [
        {
          title: 'pages.costInvoice.tabs.status:clear',
          customFilterFn: (data: MetaData<any>[]) =>
            data.filter((item) => {
              const status = item.status?.meta?.('rawvalue').toUpperCase();
              return status === 'CLEAR';
            }),
        },
        {
          title: 'pages.costInvoice.tabs.status:unclear',
          customFilterFn: (data: MetaData<any>[]) =>
            data.filter((item) => {
              const status = item.status?.meta?.('rawvalue').toUpperCase();
              return status === 'UNCLEAR';
            }),
        },
      ],
    },
  ];
}
